<div
  class="relative w-full flex-col bg-contrast border-r border-ui-separator overflow-auto beautyScroll transition-all duration-120"
  [ngClass]="{
    'hidden lg:flex h-full': forDesktop,
    'h-[calc(100dvh-58px)]': !forDesktop,
    'pb-0!': !admins?.[0]?.hidden,
    'w-[60px]! py-lg px-0 pb-lg pt-lg': isCollapsed && forDesktop,
    'w-[320px]! py-lg px-sm pb-2xl': !isCollapsed && forDesktop
  }"
>
  <!-- Menu Content -->
  <div class="flex-1 flex flex-col overflow-y-auto beautyScroll">
    <!-- Expanded Menu View -->
    @if (!isCollapsed) {
      <!-- Logo -->
      <div
        class="hidden lg:flex items-center justify-between sticky top-0 bg-contrast px-lg pb-[18px] border-b border-ui-separator"
      >
        <div class="cursor-pointer" (click)="showLargeMenuChanged.emit(false)">
          <img src="assets/images/icons/new-big-logo.svg" alt="Logo" class="h-[36px] dark:hidden" />
          <img
            src="assets/images/icons/new-big-logo-darkmode.svg"
            alt="Logo"
            class="h-[36px] hidden dark:block"
          />
        </div>
        <lla-announcements-menu class="mr-2xs"></lla-announcements-menu>
      </div>

      <!-- Search Box -->
      <div class="search-container">
        <div class="search-input-wrapper">
          <svg-icon key="search" class="search-icon"></svg-icon>
          <input
            type="text"
            class="search-input"
            placeholder="Search menu..."
            [formControl]="searchControl"
            [matAutocomplete]="menuSearch"
            (focus)="onSearchFocus()"
          />
        </div>
        <mat-autocomplete
          #menuSearch="matAutocomplete"
          (optionSelected)="onSearchOptionSelected($event.option.value)"
          [displayWith]="displaySearchFn"
          panelWidth="auto"
          class="menu-search-autocomplete"
        >
          @for (item of filteredSearchItems$ | async; track item.path + item.label) {
            <mat-option [value]="item">
              @if (item.parentLabel) {
                @let ph = highlightMatch(item.parentLabel);
                <span class="text-txt-secondary text-xs"
                  >{{ ph.before }}<strong class="text-primary font-semibold">{{ ph.match }}</strong
                  >{{ ph.after }}</span
                >
                <span class="text-txt-secondary text-xs mx-2xs">&rsaquo;</span>
              }
              @let lh = highlightMatch(item.label);
              <span class="text-sm text-txt"
                >{{ lh.before }}<strong class="text-primary font-semibold">{{ lh.match }}</strong
                >{{ lh.after }}</span
              >
            </mat-option>
          }
        </mat-autocomplete>
      </div>

      <!-- Main Items -->
      <div>
        @for (item of mains; track item) {
          <ng-container *ngTemplateOutlet="expandableMenuItem; context: { item: item }"></ng-container>
        }
      </div>

      <!-- Service Items -->
      <div>
        @for (item of services; track item) {
          <ng-container *ngTemplateOutlet="expandableMenuItem; context: { item: item }"></ng-container>
        }
      </div>

      <!-- Bookmarks Items -->
      @if (bookmarks && bookmarks.length > 0) {
        <div class="group-header cursor-pointer" (click)="toggleSection('bookmarks')">
          <div class="flex items-center gap-sm">
            <svg-icon key="bookmark" class="text-sm!"></svg-icon>
            <span>Bookmarks</span>
          </div>
          <div class="flex text-txt-disabled">
            <svg-icon
              [key]="isSectionExpanded('bookmarks') ? 'minus' : 'plus'"
              class="text-2xs!"
            ></svg-icon>
          </div>
        </div>
        @if (isSectionExpanded('bookmarks')) {
          <div>
            @for (item of bookmarks; track item) {
              <ng-container
                *ngTemplateOutlet="expandableMenuItem; context: { item: item }"
              ></ng-container>
            }
          </div>
        }
      }

      <!-- Admin Items -->
      @if (!admins?.[0]?.hidden) {
        @for (item of admins; track item) {
          @if (!item.hidden) {
            <div class="group-header cursor-pointer" (click)="toggleSection('admin')">
              <div class="flex items-center gap-sm">
                <svg-icon key="settings" class="text-base!"></svg-icon>
                <span>{{ item.label }}</span>
              </div>
              <div class="flex text-txt-disabled">
                <svg-icon
                  [key]="isSectionExpanded('admin') ? 'minus' : 'plus'"
                  class="text-2xs!"
                ></svg-icon>
              </div>
            </div>
            @if (isSectionExpanded('admin')) {
              @for (subMenu of item.subMenus; track subMenu) {
                <ng-container
                  *ngTemplateOutlet="
                    expandableMenuItem;
                    context: { item: subMenu, parentKey: '' + item.index }
                  "
                ></ng-container>
              }
            }
          }
        }
      }
    }
    <!-- Collapsed Menu View - Icons Only -->
    @else {
      <!-- Logo -->
      <div
        class="sticky top-0 bg-contrast z-5100 px-base mx-xs pb-[18px] cursor-pointer border-b border-ui-separator"
        (click)="showLargeMenuChanged.emit(true)"
      >
        <img src="assets/images/icons/new-logo.svg" alt="Logo" class="h-[36px] dark:hidden" />
        <img
          src="assets/images/icons/new-logo-darkmode.svg"
          alt="Logo"
          class="h-[36px] hidden dark:block"
        />
      </div>

      <div class="hidden lg:flex justify-center mt-sm w-full">
        <lla-announcements-menu></lla-announcements-menu>
      </div>

      <div class="mt-sm flex flex-col items-start gap-2xs">
        @for (item of mains; track item) {
          @if (!item.hidden) {
            <ng-container *ngTemplateOutlet="collapsedMenuItem; context: { item: item }"></ng-container>
          }
        }
        @for (item of services; track item) {
          @if (!item.hidden) {
            <ng-container *ngTemplateOutlet="collapsedMenuItem; context: { item: item }"></ng-container>
          }
        }

        <!-- Bookmarks -->
        @if (bookmarks && bookmarks.length > 0) {
          <ng-container
            *ngTemplateOutlet="
              collapsedMenuItem;
              context: {
                item: { icon: 'bookmark', label: 'Bookmarks', subMenus: flatBookmarksWithParent }
              }
            "
          ></ng-container>
        }
      </div>
    }
  </div>

  <!-- Sticky Footer Items (Expanded Only) -->
  @if (!isCollapsed) {
    <div class="sticky bottom-0 w-full bg-contrast pb-base">
      <!-- Profile Menu Items -->
      <div class="mt-sm border-t border-ui-separator">
        <ng-container
          *ngTemplateOutlet="expandableMenuItem; context: { item: profileMenu }"
        ></ng-container>
      </div>
    </div>
  }

  <!-- Sticky Footer Items (Collapsed) -->
  @if (isCollapsed) {
    <div class="mt-auto pb-sm">
      <div class="h-px w-[40px] mx-auto pt-sm border-t border-ui-separator"></div>
      <div class="flex flex-col gap-2xs">
        @if (!admins?.[0]?.hidden) {
          <div class="flex flex-col gap-base">
            @for (item of admins; track item) {
              @if (!item.hidden) {
                <ng-container
                  *ngTemplateOutlet="collapsedMenuItem; context: { item: item }"
                ></ng-container>
              }
            }
          </div>
        }
        <div class="hidden lg:block">
          <ng-container
            *ngTemplateOutlet="collapsedMenuItem; context: { item: profileMenu }"
          ></ng-container>
        </div>
      </div>
    </div>
  }
</div>

<!-- Submenu Popup Panel -->
@if (hoveredItem && hoveredItem.subMenus && hoveredItem.subMenus.length > 0) {
  <div
    #submenuPanel
    class="submenu-panel"
    [style.top]="submenuPanelPosition?.top"
    [style.left]="submenuPanelPosition?.left"
  >
    <div
      class="p-sm pl-base mb-sm font-semibold text-sm leading-sm text-txt border-b border-ui-separator bg-gray-50 rounded-tr-sm"
    >
      {{ hoveredItem.label }}
    </div>
    <div class="flex flex-col px-xs">
      @for (subItem of hoveredItem.subMenus; track subItem; let idx = $index) {
        @if (!subItem.hidden) {
          @if (subItem.subMenus && subItem.subMenus.length > 0) {
            <!-- Group header for items with children -->
            <div class="submenu-group-header">{{ subItem.label }}</div>
            @for (childItem of subItem.subMenus; track childItem) {
              @if (!childItem.hidden) {
                <a
                  class="menu-item group"
                  [routerLink]="childItem.path"
                  [queryParams]="childItem.queryParams"
                  [target]="childItem.type === 'bookmark' ? '_blank' : '_self'"
                  [routerLinkActive]="'active-menu-item'"
                  [routerLinkActiveOptions]="{ exact: !!childItem.exact }"
                  (click)="onMenuItemClick(childItem)"
                >
                  <span class="flex-1 text-sm leading-sm pl-sm">
                    {{ childItem.label }}
                  </span>
                </a>
              }
            }
            @if (!isLastVisibleSubmenuItem(hoveredItem.subMenus!, idx)) {
              <div class="submenu-group-separator"></div>
            }
          } @else {
            <!-- Regular leaf item -->
            <a
              class="menu-item group"
              [routerLink]="subItem.path"
              [queryParams]="subItem.queryParams"
              [target]="subItem.type === 'bookmark' ? '_blank' : '_self'"
              [routerLinkActive]="'active-menu-item'"
              [routerLinkActiveOptions]="{ exact: !!subItem.exact }"
              (click)="onMenuItemClick(subItem)"
            >
              <div class="flex-1 flex items-center">
                <span class="flex-1 text-sm leading-sm pl-sm"> {{ subItem.label }} </span>
                @if (subItem.rightIcon) {
                  <div class="flex">
                    <svg-icon [key]="subItem.rightIcon" class="text-sm!"></svg-icon>
                  </div>
                }
              </div>
            </a>
          }
        }
      }
    </div>
  </div>
}

<!-- Expandable Menu Item Template (for Expanded View) -->
<ng-template
  #expandableMenuItem
  let-item="item"
  let-isAdmin="isAdmin"
  let-parentKey="parentKey"
  let-nestLevel="nestLevel"
>
  @if (!item.hidden) {
    <div>
      @if (!isAdmin) {
        <div (click)="changeCollapsableMenuStatus(item, parentKey)">
          <ng-container
            *ngTemplateOutlet="
              menuItem;
              context: { item: item, nestLevel: nestLevel, parentKey: parentKey }
            "
          ></ng-container>
        </div>
      }
      @if (isSubMenuVisible(item, parentKey) || isAdmin) {
        @for (subMenu of item.subMenus; track subMenu) {
          @if (subMenu.subMenus && subMenu.subMenus.length > 0) {
            <ng-container
              *ngTemplateOutlet="
                expandableMenuItem;
                context: {
                  item: subMenu,
                  parentKey: parentKey ? parentKey + '-' + item.index : '' + item.index,
                  nestLevel: (nestLevel || 0) + 1
                }
              "
            ></ng-container>
          } @else {
            <ng-container
              *ngTemplateOutlet="
                menuItem;
                context: {
                  item: subMenu,
                  isSubMenuItem: !isAdmin,
                  nestLevel: (nestLevel || 0) + 1
                }
              "
            ></ng-container>
          }
        }
      }
    </div>
  }
</ng-template>

<!-- Item Template -->
<ng-template
  #menuItem
  let-item="item"
  let-isSubMenuItem="isSubMenuItem"
  let-nestLevel="nestLevel"
  let-parentKey="parentKey"
  let-hidePlusIcon="hidePlusIcon"
>
  @if (!item.hidden) {
    <a
      class="menu-item group"
      [ngClass]="{ 'text-sm! leading-sm!': isSubMenuItem || nestLevel > 0 }"
      [routerLink]="item.path"
      [queryParams]="item.queryParams"
      [routerLinkActive]="item.type === 'bookmark' ? '' : 'active-menu-item'"
      [routerLinkActiveOptions]="{ exact: !!item.exact }"
      [target]="item.type === 'bookmark' ? '_blank' : '_self'"
      (click)="onMenuItemClick(item)"
    >
      <div class="flex" [style.margin-left.px]="nestLevel > 1 ? (nestLevel || 0) * 5 : 0">
        <svg-icon
          [key]="item.icon"
          [fontSize]="isSubMenuItem || nestLevel > 1 ? '8px' : '15px'"
          [ngClass]="{ 'ml-[10px]': isSubMenuItem || nestLevel > 1 }"
        ></svg-icon>
      </div>
      <span
        class="flex-1 overflow-hidden transition-opacity duration-120"
        [ngClass]="{
          'pl-base': !isSubMenuItem && (!nestLevel || nestLevel === 0),
          'pl-[10px]': isSubMenuItem || nestLevel > 0,
          'opacity-0': isCollapsed,
          'opacity-100': !isCollapsed
        }"
      >
        {{ item.label }}
      </span>
      @if (item.rightIcon && !item.subMenus) {
        <div
          class="pl-base flex transition-opacity duration-120"
          [class.opacity-0]="isCollapsed"
          [class.opacity-100]="!isCollapsed"
        >
          <svg-icon [key]="item.rightIcon" class="text-sm!"></svg-icon>
        </div>
      }
      @if (item.subMenus && !hidePlusIcon) {
        <div
          class="pl-base flex text-txt-disabled transition-opacity duration-120"
          [class.opacity-0]="isCollapsed"
          [class.opacity-100]="!isCollapsed"
        >
          <svg-icon
            [key]="
              expandedIndexes.has(parentKey ? parentKey + '-' + item.index : '' + item.index)
                ? 'minus'
                : 'plus'
            "
            class="text-2xs!"
          ></svg-icon>
        </div>
      }
      @if (item.type === 'bookmark' && !item.subMenus) {
        <div
          (click)="deleteBookmark($event, item.extraInfo)"
          class="pl-base -mr-[3px] hidden group-hover:flex items-center transition-opacity duration-120"
          [class.opacity-0]="isCollapsed"
          [class.opacity-100]="!isCollapsed"
        >
          <div class="flex text-txt-secondary">
            @if (deletingBookmarkId !== item.extraInfo) {
              <svg-icon key="close-circle" class="text-sm!"></svg-icon>
            }
          </div>
          @if (deletingBookmarkId === item.extraInfo) {
            <lla-loading-spinner></lla-loading-spinner>
          }
        </div>
      }
    </a>
  }
</ng-template>

<!-- Collapsed Menu Item Template -->
<ng-template #collapsedMenuItem let-item="item">
  <div
    class="menu-item-collapsed w-full"
    [routerLink]="!item.subMenus ? item.path : null"
    [queryParams]="item.queryParams"
    (click)="
      item.subMenus && item.subMenus.length > 0
        ? onCollapsedMenuItemClick(item, $event)
        : onMenuItemClick(item)
    "
  >
    <div
      class="collapsed-item-container"
      [class.active-menu-item]="hasActiveSubmenu(item)"
      [class.submenu-open]="hoveredItem === item"
      [routerLinkActive]="!item.subMenus ? 'active-menu-item' : ''"
      [routerLinkActiveOptions]="{ exact: !!item.exact }"
      [matTooltip]="item.label"
      matTooltipClass="lla-tooltip-cell"
      [matTooltipPosition]="'right'"
    >
      <svg-icon [key]="item.icon" class="text-base!"></svg-icon>
      @if (item.subMenus && item.subMenus.length > 0) {
        <div class="dot-icon"></div>
      }
    </div>
  </div>
</ng-template>
